"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableOpAmps = getAvailableOpAmps;
exports.getIdealOpAmp1 = getIdealOpAmp1;
exports.getIdealOpAmp2 = getIdealOpAmp2;
var Stages = _interopRequireWildcard(require("./stages"));
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function getAvailableOpAmps(opAmpDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages, stage1OpAmpName, stageIndex) {
  let inputValues = {
    sensor: sensor,
    reverseVoltage: Vr,
    biasPreference: Bias,
    capacitance: Cd,
    shuntResistance: Rsh,
    peakCurrent: Ip,
    peakVoltage: peakVoltage,
    speed: speed,
    peaking: peaking,
    stages: numberOfStages
  };
  let result = opAmpRecommendationStatus(opAmpDb, stageIndex, inputValues, stage1OpAmpName);
  return result;
}
function getIdealOpAmp1(opAmpDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages) {
  let inputValues = {
    sensor: sensor,
    reverseVoltage: Vr,
    biasPreference: Bias,
    capacitance: Cd,
    shuntResistance: Rsh,
    peakCurrent: Ip,
    peakVoltage: peakVoltage,
    speed: speed,
    peaking: peaking,
    stages: numberOfStages
  };
  let result;
  if (numberOfStages === _photodiodeConstants.default.pdStages.oneStage) {
    result = Stages.findOpAmp(inputValues, opAmpDb);
  } else {
    result = Stages.findOpAmp1(inputValues, opAmpDb);
  }
  return result;
}
function getIdealOpAmp2(opAmpDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages, stage1OpAmpPartNumber) {
  let inputValues = {
    sensor: sensor,
    reverseVoltage: Vr,
    biasPreference: Bias,
    capacitance: Cd,
    shuntResistance: Rsh,
    peakCurrent: Ip,
    peakVoltage: peakVoltage,
    speed: speed,
    peaking: peaking,
    stages: numberOfStages
  };
  let result;
  if (numberOfStages === _photodiodeConstants.default.pdStages.oneStage) {
    result = null;
  } else {
    result = Stages.findOpAmp2(inputValues, opAmpDb, stage1OpAmpPartNumber);
  }
  return result;
}

//PRIVATE
function opAmpRecommendationStatus(opAmpDB, stageIndex, userInputs, stage1OpAmpName) {
  let result = [];
  let stage1OpAmp;
  for (let i = 0; i < opAmpDB.length; i++) {
    let opAmp = opAmpDB[i];
    let stageInfo;
    if (stageIndex === 1 && userInputs.stages === _photodiodeConstants.default.pdStages.oneStage) {
      stageInfo = Stages.stage1Info_SingleStage(Stages.oneStageRf(userInputs).rf, userInputs, opAmp);
    } else if (stageIndex === 1 && userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
      stageInfo = Stages.stage1Info_DualStage(userInputs, opAmp);
    } else if (stageIndex === 2 && userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
      if (!stage1OpAmp) {
        for (let j = 0; j < opAmpDB.length; j++) {
          if (opAmpDB[j].partNumber === stage1OpAmpName) {
            stage1OpAmp = opAmpDB[j];
            break;
          }
        }
      }
      stageInfo = Stages.stage2Info(userInputs, opAmp, stage1OpAmp);
    } else {
      return result;
    }
    let status = _messages.default.amp_status_recommended;
    let comment = [];
    let selectable = true;
    let disallowed = false;
    switch (stageInfo.status) {
      case _photodiodeConstants.default.opAmpStatus.allowed:
        status = _messages.default.amp_status_not_recommended;
        selectable = true;
        disallowed = false;
        comment = stageInfo.statusMessage;
        break;
      case _photodiodeConstants.default.opAmpStatus.notAllowed:
        status = _messages.default.amp_status_not_allowed;
        selectable = false;
        disallowed = true;
        comment = stageInfo.statusMessage;
        break;
      case _photodiodeConstants.default.opAmpStatus.recommended:
        status = _messages.default.amp_status_recommended;
        selectable = true;
        disallowed = false;
        break;
    }
    var opAmpListItem = {
      selectable: selectable,
      disallowed: disallowed,
      status: status,
      comment: comment,
      partNumber: opAmp.partNumber,
      scdFlag: false
    };
    result.push(opAmpListItem);
  }
  return result;
}